//@flow

import { useEffect, useState } from 'react';

// Returns ms left until `expireAt` (epoch ms), updated every second; null when inactive.
const useCountdown = (expireAt: ?number, active: boolean = true): ?number => {
  const [remainingMs, setRemainingMs] = useState(null);

  useEffect(() => {
    if (!expireAt || !active) {
      setRemainingMs(null);
      return undefined;
    }
    const tick = () => setRemainingMs(Math.max(0, expireAt - Date.now()));
    tick();
    const intervalId = setInterval(tick, 1000);
    return () => clearInterval(intervalId);
  }, [expireAt, active]);

  return remainingMs;
};

export default useCountdown;
